import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router'

// Components
import { App } from '../../../App';
import { ModelList } from '../../../components/PaginatedList/ModelList';


// Redux

import { FullEngagements } from './redux/userengagement.selectors';
import { searchEngagements } from './redux/userengagement.actions';
import { PaginatedList } from '../../../components/PaginatedList/PaginatedList';
import { AssetCard } from '../Assets/AssetCard';
import { ImageCroppingPresets } from '../../../modules/Media/MediaUtils';
import { StyledFullScreenModal } from '../../components/Content/FullScreenModal';
import { AssetViewer } from '../Assets/AssetViewer';

export const PageSaved = () => {

    // New Modal
    const dispatch = useDispatch();
    const store = FullEngagements();
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(999);
    const [openViewer, setOpenViewer] = useState(false);
    const [activeAsset, setActiveAsset] = useState(null);

    useEffect(() => {
        const args = {}
        args.engagement = `["save"]`
        args['prefix'] = 'saves';
        dispatch(searchEngagements(0, 999, null, null, args));
    }, [])



    // --------------------------
    // Interactions
    // --------------------------

    // On Select
    const handleSelect = (item) => {
        dispatch(push(`/asset/${item.id}`))
        // setActiveAsset(item);
        // setOpenViewer(true);
    }


    //<AlbumList onSelect={handleSelect} filters={{ LibraryId: `["${id}"]` }} />

    const formatted = (store?.saves) ? store?.saves.rows.map(item => {
        if (!item?.item) return null;
        return { id: item.item.id, title: item.item.name, description: '', full: item.item }
    }
    ) : []
    const total = (store?.saves) ? store?.saves?.count : 0;
    const pageCount = Math.ceil(total / limit);

    const renderMediaCard = (item, onClickItem) => (<AssetCard display="feed" item={item} onClick={onClickItem} crop={ImageCroppingPresets.preview} noControls={true} />)


    // Render Page
    return (
        <App title="Saved Assets">

            <PaginatedList
                onClickItem={handleSelect}
                loading={store?.itemsLoading}
                items={formatted}
                total={total}
                pages={pageCount}
                currentPage={page}
                variant="cards"
                customRenderer={renderMediaCard}
                noControls={true}

            />
            <StyledFullScreenModal open={openViewer} onClose={() => setOpenViewer(false)} fullWidth>
                <AssetViewer onClose={() => setOpenViewer(false)} asset={activeAsset} />
            </StyledFullScreenModal>

        </App>
    )
}